import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

export interface uploadHistoryList {
  name: string;
  url?: string;
  errorUrl?: string;
  status: number;
  uploadBy: string;
  date: string;
}

@Component({
  selector: 'app-uploadhistory',
  templateUrl: './uploadhistory.component.html',
  styleUrls: ['./uploadhistory.component.css']
})

export class UploadHistoryComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['name', 'url', 'date', 'uploadBy', 'status'];
  dataSource!: MatTableDataSource<uploadHistoryList>;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    // Use the data passed through the dialog for dataSource
    if (this?.data?.dataSource) {
      this.dataSource = this.data.dataSource;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }
}

